<template>
  <q-page class="flex column page-layout latest-news">
    <NewsAll />
  </q-page>
</template>

<script>
import NewsAll from "@/views/news/NewsAll.vue";
export default {
  name: "LatestNews",
  components: {
    NewsAll,
  },
};
</script>
